<template>
  <div class="public-content recharge-enquiry">
    <div class="breadcrumb">升级版本</div>
    <div class="right-main">
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="8">
            <el-form-item label="升级类型:" class="el-date-width">
              <el-select v-model="formInline.method" placeholder="请选择类型" clearable>
                <el-option v-for="(item, index) in upgradeList" :label="item.label" :value="item.value" :key="'aaa' + index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
            <el-button class="search-ok" @click="detail" round type="primary">升级版本</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" :row-class-name="rowClassName" border style="width: 100%">
          <el-table-column prop="terminalType" label="系统平台" min-width="150"></el-table-column>
          <el-table-column prop="version" label="版本号" min-width="130"></el-table-column>
          <el-table-column prop="method" label="升级类型" min-width="180">
            <template v-slot="scope"> {{ scope.row.method == 1 ? '不提示升级' : scope.row.method == 2 ? '弱提示升级' : scope.row.method == 3 ? '强提示升级' : '强制升级' }} </template>
          </el-table-column>
          <el-table-column prop="context" label="升级提示语" min-width="180"></el-table-column>
          <el-table-column prop="downloadUrl" label="下载地址" min-width="130"></el-table-column>
          <el-table-column prop="sysUpTime" label="更新时间" min-width="180"></el-table-column>
          <el-table-column label="操作" min-width="180">
            <template v-slot="scope">
              <span class="color-blue" @click="detail(scope.row)" v-if="!scope.row.publishStatus">编辑</span>
              <span class="color-blue" @click="detail(scope.row, 'check')" v-else>查看</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页-->
      <v-pagination class="v-pagination" @changePage="changePage" :queryInfo='queryInfo'></v-pagination>
    </div>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { promoPage, exportAnalysisEpay, getAnalysisEpay } from '@/api/epay'
import { storeQueryListByCode, getSalesmanByFullName, storeQueryListByName, getlistByMethod } from '@/api/crm'
export default {
  name: 'upgradeVersion',
  components: {
    VPagination
  },
  data () {
    return {
      storeListByCode: [],
      storeListByName: [],
      salemanList: [],
      auditedData: [],
      dialogVisible: false,
      storeName: '',
      code: '',
      fullName: '',
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      formInline: {
        method: ''
      },
      tableData: [],
      upgradeList: [{
        label: '不提示升级',
        value: 1
      }, {
        label: '弱提示升级',
        value: 2
      }, {
        label: '强提示升级',
        value: 3
      }, {
        label: '强制升级',
        value: 4
      }]
    }
  },
  created () {
    this.onSubmit()
  },
  methods: {
    detail (val, type = '') {
      if (!type) {
        const currentTime = new Date()
        const compareTime = new Date(val.sysUpTime)
        // 比当前时间晚，可以编辑
        if (compareTime > currentTime || !val.id) {
          this.$router.push({ path: '/app/upgradeVersionDetail', query: { detail: JSON.stringify(val) } })
        } else {
          this.$message.error('当前版本已经发布升级消息，不可编辑')
        }
      } else {
        this.$router.push({ path: '/app/upgradeVersionDetail', query: { detail: JSON.stringify(val), type: type } })
      }
    },
    onSubmit () {
      // let param = JSON.parse(JSON.stringify(this.formInline))
      // Object.keys(param).forEach((key) => (param[key] === '' || param[key] === null) && delete param[key])
      getlistByMethod({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, Vo: this.formInline }).then((res) => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.records
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
// @import "index";
@deep: ~">>>";
</style>
